import { isEmptyCell } from './board.js';
import { pieceCells, rotate } from './piece.js';
export function canPlace(board, piece) {
    return pieceCells(piece).every((c) => isEmptyCell(board, c.x, c.y));
}
export function tryShift(board, piece, dx, dy) {
    const moved = { ...piece, x: piece.x + dx, y: piece.y + dy };
    return canPlace(board, moved) ? moved : null;
}
const WALL_KICKS = [
    [0, 0],
    [-1, 0],
];
const CEILING_KICKS = [
    [0, 1],
    [-1, 1],
];
/**
 * Поворот с отскоком: сначала на месте, затем на клетку влево.
 * Если повёрнутая капсула упирается в верхний край поля, дополнительно пробуется сдвиг на строку вниз.
 */
export function tryRotate(board, piece, direction) {
    const rotated = { ...piece, rotation: rotate(piece.rotation, direction) };
    const hitsCeiling = pieceCells(rotated).some((c) => c.y < 0);
    const kicks = hitsCeiling ? [...WALL_KICKS, ...CEILING_KICKS] : WALL_KICKS;
    for (const [dx, dy] of kicks) {
        const candidate = tryShift(board, rotated, dx, dy);
        if (candidate) {
            return candidate;
        }
    }
    return null;
}
/** Самая нижняя допустимая позиция при падении по вертикали. */
export function dropPosition(board, piece) {
    let current = piece;
    for (let next = tryShift(board, current, 0, 1); next; next = tryShift(board, current, 0, 1)) {
        current = next;
    }
    return current;
}
//# sourceMappingURL=movement-resolver.js.map